// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { Resources } from "../../Commons/properties/Resources.js";


export let ColumnParams = function (headerKey, //1
                             width,     //2
                             columnType,//3
                             showTotal,//4
                             visible,//5
                             allowGrouping,//6
                             hidden,//7
                             beginGroupFlag,//8
                             emptyValue,//9
                             canEdit)//10
{

    /// <summary>
    /// Ключ колонки
    /// </summary>
    this.HeaderKey = headerKey;
    /// <summary>
    /// Видимость тотала для колонки
    /// </summary>
    this.ShowTotal = showTotal;

    /// <summary>
    /// Тип колонки
    /// </summary>
    this.ColumnType = columnType;
    /// <summary>
    /// Ширина колонки
    /// </summary>
    this.Width = width;
    /// <summary>
    /// Видимость колонки
    /// </summary>
    this.Visible = visible;

    /// <summary>
    /// Скрытая колонка
    /// </summary>
    this.Hidden = hidden || false;

    /// <summary>
    /// Разрешено/запрещено группирование для этой колонки
    /// </summary>
    this.AllowGrouping = allowGrouping;
    /// <summary>
    /// Указывает, должна ли начинаться новая группа в меню
    /// </summary>
    this.BeginGroup = beginGroupFlag || false;
    /// <summary>
    /// Значение, которое должно игнорироваться при расчете тотала
    /// </summary>

    this.EmptyValue = emptyValue || 0;

    //#region Properties

    // #86290
    this.CanEdit = canEdit || false;

    /// <summary>
    /// Для ВЕБа - на обновление данных должно сравниваться (строковое значение, а не getValue)
    /// </summary>
    this.TextCompareColumn = false

    /// <summary>
    /// Установить язык, который будет использоваться
    /// </summary>
    this.Locale = "";

    /// <summary>
    /// Использовать форматирование цены
    /// </summary>
    this.FormatPrice = false;

    this.FormulaKey = "";

    this.MenuIndex = 1000;

    this.AutoGenerated = false;
    //#endregion
}


/// <summary>
/// Текст колонки (локализированный)
/// </summary>
ColumnParams.prototype.HeaderText = function ()
{
    if (this.Locale == null)
        return Resources.getResource(this.HeaderKey);
    else
        return this.HeaderKey;
    //    return Resources.getResourceLang(this.HeaderKey, this.Locale);
}

/// <summary>
/// Текст tooltip'a (всегда берется, как комбинация HeaderKey + ".descr", если не существует такого ключа, то вернется HeaderText)
/// </summary>
//public string ToolTip
//{
//    get
//    {
//        if (Locale == null)
//            if (Resources.IsResourcePresent(HeaderKey + ".descr"))
//                return Resources.getResource(HeaderKey + ".descr");
//            else
//                return Resources.getResource(HeaderKey);
//        else
//        {
//            if (Resources.IsResourcePresent(HeaderKey + ".descr", Locale))
//                return Resources.getResourceLang(HeaderKey + ".descr", Locale);
//            else
//                return Resources.getResource(HeaderKey, Locale);
//        }
//    }
//}
